import { defineApp } from 'umi'

export default defineApp({})
